import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  callApi,
  getAdditionalInfo,
  saveAdditionalInfo,
} from "../../services/apiService";
import { getUserInfo } from "../../services/authService";
import { NotificationManager } from "react-notifications";
import Button from "../../components/buttons/button";
import { FormProvider, useForm } from "react-hook-form";
import {
  aditionalInfoEnum,
  generalStatesPostulation,
  yesNo,
} from "../../constants/enum";
import AutocompleteSelect from "../../components/forms/inputsMui/autocomplete";
import { FormSteps } from "../../constants/enum";

const AdditionalInfo = ({ setState, postulationState, programName }) => {
  const { t } = useTranslation();
  const [idAdditionalInfo, setIdAdditionalInfo] = useState({});

  const loadDataFormAdditionalInfo = (obj) => {
    const fields = [
      "driving",
      "swim",
      "ski",
      "cpr",
      "lifeGuard",
      "isTravelingWithFriend",
    ];

    fields.forEach((field) => {
      if (obj[field] === true) {
        obj[field] = aditionalInfoEnum.SI;
      } else if (obj[field] === false) {
        obj[field] = aditionalInfoEnum.NO;
      }
      setValue(field, !obj || !obj[field] ? "" : obj[field]);
    });
    setValue("nameTravelingFriend", obj.nameTravelingFriend || "");
  };

  const defaultValues = {};
  const methods = useForm({ defaultValues });
  const {
    control,
    register,
    setValue,
    watch,
    handleSubmit,
    formState: { errors },
  } = methods;

  const validations = {
    driving: {
      required: { value: true, message: t("form.visa.error") },
    },
    swim: {
      required: { value: true, message: t("form.visa.error") },
    },
    ski: {
      required: { value: true, message: t("form.visa.error") },
    },
    lifeGuard: {
      required: { value: true, message: t("form.visa.error") },
    },
    cpr: {
      required: { value: true, message: t("form.visa.error") },
    },
    isTravelingWithFriend: {
      required: { value: true, message: t("form.visa.error") },
    },
    nameTravelingFriend: {
      validate: (value) =>
        watch("isTravelingWithFriend") == aditionalInfoEnum.SI
          ? value.trim() !== "" || t("form.visa.error")
          : true,
    },
  };

  useEffect(() => {
    const uId = getUserInfo().id;
    callApi(
      () => getAdditionalInfo({ uId: uId }),
      (data) => {
        setIdAdditionalInfo(data.idTraveler);
        loadDataFormAdditionalInfo(data);
      }
    );
  }, []);

  const onSubmitAdditionalInfo = handleSubmit((data) => {
    const uId = getUserInfo().id;
    const submitData = {
      uId: uId,
      driving: data.driving === aditionalInfoEnum.SI ? true : false,
      swim: data.swim === aditionalInfoEnum.SI ? true : false,
      ski: data.ski === aditionalInfoEnum.SI ? true : false,
      lifeGuard: data.lifeGuard === aditionalInfoEnum.SI ? true : false,
      cpr: data.cpr === aditionalInfoEnum.SI ? true : false,
      isTravelingWithFriend:
        data.isTravelingWithFriend === aditionalInfoEnum.SI ? true : false,
      nameTravelingFriend:
        data.isTravelingWithFriend === aditionalInfoEnum.SI
          ? data.nameTravelingFriend || ""
          : "",
      idAdditionalInfo: idAdditionalInfo,
      postulationState: postulationState,
    };

    callApi(
      () => saveAdditionalInfo(submitData),
      () => {
        NotificationManager.success(t("form.success"));
        setState(FormSteps.WorkDates);
      }
    );
  });
  const backForm = () => {
    setState(FormSteps.LanguageSkills);
  };

  return (
    <>
      <h2 className="title">{t("form.program") + programName}</h2>
      <h2>{t("form.aditionalInfo.title")}</h2>
      <FormProvider {...methods}>
        <form>
          <div className="container-inputs">
            {/*  driving */}
            <div className="inputs-style">
              <label>
                {t("form.aditionalInfo.driving")}
                <span className="text-danger"> *</span>
              </label>
              <AutocompleteSelect
                name="driving"
                label={t("form.aditionalInfo.driving")}
                options={yesNo()}
                register={register}
                registerOptions={validations}
                watch={watch}
                setValue={setValue}
              />
              {watch("driving") == "" && (
                <span className="text-danger text-small d-block mb-2 validation-margin">
                  {errors.driving && errors.driving.message}
                </span>
              )}
            </div>
            {/* swim */}
            <div className="inputs-style">
              <label>
                {t("form.aditionalInfo.swim")}
                <span className="text-danger"> *</span>
              </label>
              <AutocompleteSelect
                name="swim"
                label={t("form.aditionalInfo.swim")}
                options={yesNo()}
                register={register}
                registerOptions={validations}
                watch={watch}
                setValue={setValue}
              />
              {watch("swim") == "" && (
                <span className="text-danger text-small d-block mb-2 validation-margin">
                  {errors.swim && errors.swim.message}
                </span>
              )}
            </div>
          </div>
          <div className="container-inputs">
            {/*  ski */}
            <div className="inputs-style">
              <label>
                {t("form.aditionalInfo.ski")}
                <span className="text-danger"> *</span>
              </label>
              <AutocompleteSelect
                name="ski"
                label={t("form.aditionalInfo.ski")}
                options={yesNo()}
                register={register}
                registerOptions={validations}
                watch={watch}
                setValue={setValue}
              />
              {watch("ski") == "" && (
                <span className="text-danger text-small d-block mb-2 validation-margin">
                  {errors.ski && errors.ski.message}
                </span>
              )}
            </div>
            {/* lifeGuard */}
            <div className="inputs-style">
              <label>
                {t("form.aditionalInfo.lifeGuard")}
                <span className="text-danger"> *</span>
              </label>
              <AutocompleteSelect
                name="lifeGuard"
                label={t("form.aditionalInfo.lifeGuard")}
                options={yesNo()}
                register={register}
                registerOptions={validations}
                watch={watch}
                setValue={setValue}
              />
              {watch("lifeGuard") == "" && (
                <span className="text-danger text-small d-block mb-2 validation-margin">
                  {errors.lifeGuard && errors.lifeGuard.message}
                </span>
              )}
            </div>
          </div>
          <div className="container-inputs">
            {/*  cpr */}
            <div className="inputs-style">
              <label>
                {t("form.aditionalInfo.cpr")}
                <span className="text-danger"> *</span>
              </label>
              <AutocompleteSelect
                name="cpr"
                label={t("form.aditionalInfo.cpr")}
                options={yesNo()}
                register={register}
                registerOptions={validations}
                watch={watch}
                setValue={setValue}
              />
              {watch("cpr") == "" && (
                <span className="text-danger text-small d-block mb-2 validation-margin">
                  {errors.cpr && errors.cpr.message}
                </span>
              )}
            </div>
            <div className="inputs-style">
              <label>
                {t("aditionalInfo.travelWithFriend")}
                <span className="text-danger"> *</span>
              </label>
              <AutocompleteSelect
                name="isTravelingWithFriend"
                label={t("aditionalInfo.travelWithFriend")}
                options={yesNo()}
                register={register}
                registerOptions={validations}
                watch={watch}
                setValue={setValue}
              />
              {watch("isTravelingWithFriend") == "" && (
                <span className="text-danger text-small d-block mb-2 validation-margin">
                  {errors.isTravelingWithFriend &&
                    errors.isTravelingWithFriend.message}
                </span>
              )}
            </div>
          </div>
          {watch("isTravelingWithFriend") == aditionalInfoEnum.SI && (
            <div className="container-inputs">
              <div className="inputs-style">
                <label>
                  {t("aditionalInfo.nameFriend")}
                  <span className="text-danger"> *</span>
                </label>
                <input
                  placeholder={t("aditionalInfo.nameFriend")}
                  className="form-control mb-2"
                  name="nameTravelingFriend"
                  {...register(
                    "nameTravelingFriend",
                    validations.nameTravelingFriend
                  )}
                />
                {errors.nameTravelingFriend && (
                  <span className="text-danger text-small d-block mb-2 validation-margin">
                    {errors.nameTravelingFriend.message}
                  </span>
                )}
              </div>
            </div>
          )}
        </form>
      </FormProvider>
      <div className="container-inputs">
        <Button
          size="btn-sx"
          type="ww-btn-secondary"
          label={t("main.back")}
          onClick={() => backForm()}
        />
        <Button
          size="btn-sx"
          onClick={onSubmitAdditionalInfo}
          label={t("main.next")}
        />
      </div>
      {postulationState >= generalStatesPostulation.uploadingFiles && (
        <Button
          type="ww-btn-secondary"
          onClick={() => {
            setState(FormSteps.FinishedForm);
          }}
          label={t("main.backPostulation")}
        />
      )}
    </>
  );
};

export default AdditionalInfo;
